import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, reactive, ref, watch, computed } from 'vue';
import { Popup, Picker } from 'vant';
import request from '@/utils/request'
interface IProp {
    show?: boolean;
    value: string | number | boolean | null;
    text: string;
    columns?: Array<Record<string, string | number | boolean>>;
    enum?: Record<string, string | number | boolean>;
    url?: string;
    method?: 'get' | 'post';
    textField?: string;
    valueField?: string;
    optional?: boolean;
    optionalText?: string;
    optionalValue?: string | number | boolean;
    optionalLead?: boolean;//空选项是否在第一选项，默认true
}

export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean, null], default: "" },
    text: { default: "" },
    columns: { default: null },
    enum: { default: null },
    url: { default: "" },
    method: { default: "get" },
    textField: { default: "text" },
    valueField: { default: "value" },
    optional: { type: Boolean, default: false },
    optionalText: { default: "无" },
    optionalValue: { type: [String, Number, Boolean], default: "" },
    optionalLead: { type: Boolean, default: true }
  },
  emits: ["update:show", "update:value", "update:text", "confirm", "change"],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, value: string | number | boolean | null, text: string, columns: Array<Record<string, string | number | boolean>>, enum: Record<string, string | number | boolean>, url: string, method: 'get' | 'post', textField: string, valueField: string, optional: boolean, optionalText: string, optionalValue: string | number | boolean, optionalLead: boolean }




const popupShow = ref<boolean>(props.show);
watch(() => props.show, (v: boolean) => {
    popupShow.value = v;
})
watch(() => props.value, (v) => {
    setDefault(v);
})
watch(() => props.url, (v) => {
    if (v) {
        loadData();
    }
})
const onPopupClosed = () => {
    emits("update:show", false)
}
const columnsFieldNames = reactive({
    text: props.textField,
})
const defaultIndex = ref<number>(0);
const setDefault = (v) => {
    let index = pickerColumns.value.findIndex(c => c[props.valueField] == v);
    if (index != -1) {
        let selectedItem = pickerColumns.value[index];
        defaultIndex.value = index;
        emits("update:text", selectedItem.optionalOption ? "" : selectedItem[props.textField])
    } else {
        defaultIndex.value = 0;
    }
}
const loadData = async () => {
    let pickerOptions = await request({
        url: props.url,
        method: props.method,
        data: {}
    })
    if (pickerOptions && pickerOptions.length) {
        pickerColumns.value = [...pickerOptions];
    } else {
        pickerColumns.value = []
    }
}
const onChange = (currentValue, currentIndex) => {
    emits("change", currentValue, currentIndex);
}
const onConfirm = (value) => {
    popupShow.value = false;
    emits("update:text", value.optionalOption ? "" : value[props.textField])
    emits("update:value", value[props.valueField])
    emits("confirm", value);
}
const pickerColumns = ref([]);
const computedColumns = computed(() => {
    const columns = [...pickerColumns.value];
    if (props.optional) {
        let optionalObj = {
            [props.valueField]: props.optionalValue,
            [props.textField]: props.optionalText,
            optionalOption: true
        }
        if (props.optionalLead) {
            columns.unshift(optionalObj);
        } else {
            columns.push(optionalObj);
        }
    }
    return columns;
});
onMounted(async () => {
    if (props.enum) {
        for (const key in props.enum) {
            pickerColumns.value.push({
                [props.valueField]: key,
                [props.textField]: props.enum[key]
            });
        }
    } else if (props.url) {
        await loadData();
    } else if (props.columns && props.columns.length) {
        pickerColumns.value = [...props.columns]
    }
    if (props.value || props.value === 0) {
        setDefault(props.value);
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: popupShow.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((popupShow).value = $event)),
    round: "",
    position: "bottom",
    onClosed: onPopupClosed
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Picker), {
        columns: _unref(computedColumns),
        "default-index": defaultIndex.value,
        "columns-field-names": _unref(columnsFieldNames),
        "visible-item-count": "4",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (popupShow.value = false)),
        onConfirm: onConfirm,
        onChange: onChange
      }, null, 8, ["columns", "default-index", "columns-field-names"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})